import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ModuleHeader } from '@/components/ui/module-header';
import { DataTable } from '@/components/ui/data-table';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { StatusPill } from '@/components/ui/status-pill';
import { api } from '@/lib/api';

export default function SuperCompaniesPage() {
  const q = useQuery({
    queryKey: ['super-companies'],
    queryFn: async () => {
      const r = await api('/api/v1/super/companies');
      if (r.status !== 200) throw new Error('companies');
      return r.data.companies ?? [];
    },
  });

  const columns = useMemo(
    () => [
      { key: 'name', label: 'Name', sortable: true },
      {
        key: 'id',
        label: 'ID',
        render: (v) => <code className="font-mono text-xs">{String(v).slice(0, 12)}…</code>,
      },
      { key: 'plan', label: 'Plan' },
      {
        key: 'billingStatus',
        label: 'Billing',
        render: (v) => <StatusPill status={v} />,
      },
      {
        key: 'vehicleCount',
        label: 'Vehicles',
        className: 'font-mono text-right',
        sortable: true,
      },
      {
        key: 'actions',
        label: '',
        render: (_v, row) => (
          <Button asChild size="sm" variant="outline">
            <Link to={`/super/audit?companyId=${encodeURIComponent(row.id)}`}>Audit</Link>
          </Button>
        ),
      },
    ],
    []
  );

  return (
<div className="space-y-6 motion-enter">
        <ModuleHeader
          title="Companies"
          description="Tenant directory for platform navigation."
          icon="Building2"
          metrics={[{ label: 'Tenants', value: q.data?.length ?? 0 }]}
        />
        <Card>
          <CardContent className="pt-6">
            <DataTable columns={columns} data={q.data ?? []} emptyMessage="No companies" />
          </CardContent>
        </Card>
      </div>
);
}
